import styled from 'styled-components';

export const ExpanderIcon = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 0;
`;
